import { computed, h } from 'vue'
import { useCurUser } from '@/composables/useCurUser'
import { useOptionsFormatter } from '@/composables/optionsFormatter'

export const registerLastSubmissionLangColumn = (dashboard) => {
  const { hasRole } = useCurUser()
  const { languageOptions } = useOptionsFormatter()

  dashboard.registerCustomColumn({
    name: 'last_submission_lang',
    label: 'monolith.global.language',
    component: (props) => {
      const submissionLang = props.row.last_submission_lang

      if (!submissionLang) {
        return null
      }

      return h('span', submissionLang)
    },
    options: {
      visible: computed(() => hasRole(['dispatcher', 'valuer'])),
      selectOptions: languageOptions.value,
    },
  })
}
